// AUTO-GENERATED, do not edit
// It's a TypeScript wrapper for a AsyncMinterCollection contract in Tolk.
/* eslint-disable */
import * as c from '@ton/core';
import { beginCell } from '@ton/core';
function makeCellFrom(self, storeFn_T) {
    let b = beginCell();
    storeFn_T(self, b);
    return b.endCell();
}
function loadAndCheckPrefix32(s, expected, structName) {
    let prefix = s.loadUint(32);
    if (prefix !== expected) {
        throw new Error(`Incorrect prefix for '${structName}': expected 0x${expected.toString(16).padStart(8, '0')}, got 0x${prefix.toString(16).padStart(8, '0')}`);
    }
}
function lookupPrefix(s, expected, prefixLen) {
    return s.remainingBits >= prefixLen && s.preloadUint(prefixLen) === expected;
}
function throwNonePrefixMatch(fieldPath) {
    throw new Error(`Incorrect prefix for '${fieldPath}': none of variants matched`);
}
function storeCellRef(cell, b, storeFn_T) {
    let b_ref = c.beginCell();
    storeFn_T(cell.ref, b_ref);
    b.storeRef(b_ref.endCell());
}
function loadCellRef(s, loadFn_T) {
    let s_ref = s.loadRef().beginParse();
    return { ref: loadFn_T(s_ref) };
}
function storeTolkNullable(v, b, storeFn_T) {
    if (v === null) {
        b.storeUint(0, 1);
    }
    else {
        b.storeUint(1, 1);
        storeFn_T(v, b);
    }
}
function createDictionaryValue(loadFn_V, storeFn_V) {
    return {
        serialize(self, b) {
            storeFn_V(self, b);
        },
        parse(s) {
            const value = loadFn_V(s);
            s.endParse();
            return value;
        }
    };
}
// ————————————————————————————————————————————
//   parse get methods result from a TVM stack
//
class StackReader {
    tuple;
    constructor(tuple) {
        this.tuple = tuple;
    }
    static fromGetMethod(expectedN, getMethodResult) {
        let tuple = [];
        while (getMethodResult.stack.remaining) {
            tuple.push(getMethodResult.stack.pop());
        }
        if (tuple.length !== expectedN) {
            throw new Error(`expected ${expectedN} stack width, got ${tuple.length}`);
        }
        return new StackReader(tuple);
    }
    popExpecting(itemType) {
        const item = this.tuple.shift();
        if (item?.type === itemType) {
            return item;
        }
        throw new Error(`not '${itemType}' on a stack`);
    }
    popCellLike() {
        const item = this.tuple.shift();
        if (item && (item.type === 'cell' || item.type === 'slice' || item.type === 'builder')) {
            return item.cell;
        }
        throw new Error(`not cell/slice on a stack`);
    }
    readBigInt() {
        return this.popExpecting('int').value;
    }
    readBoolean() {
        return this.popExpecting('int').value !== 0n;
    }
    readCell() {
        return this.popCellLike();
    }
    readSlice() {
        return this.popCellLike().beginParse();
    }
}
export const NftItemInitAtDeployment = {
    create(args) {
        return {
            $: 'NftItemInitAtDeployment',
            isSoulbound: false,
            isRevealed: false,
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'NftItemInitAtDeployment',
            ownerAddress: s.loadAddress(),
            content: s.loadStringRefTail(),
            isSoulbound: s.loadBoolean(),
            isRevealed: s.loadBoolean(),
        };
    },
    store(self, b) {
        b.storeAddress(self.ownerAddress);
        b.storeStringRefTail(self.content);
        b.storeBit(self.isSoulbound);
        b.storeBit(self.isRevealed);
    },
    toCell(self) {
        return makeCellFrom(self, NftItemInitAtDeployment.store);
    }
};
export const ConfigureSoulbound = {
    PREFIX: 0xf000000d,
    create(args) {
        return {
            $: 'ConfigureSoulbound',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000000d, 'ConfigureSoulbound');
        return {
            $: 'ConfigureSoulbound',
            queryId: s.loadUintBig(64),
            soulbound: s.loadBoolean(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000000d, 32);
        b.storeUint(self.queryId, 64);
        b.storeBit(self.soulbound);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureSoulbound.store);
    }
};
export const FreezeMetadata = {
    PREFIX: 0xf000000f,
    create(args) {
        return {
            $: 'FreezeMetadata',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000000f, 'FreezeMetadata');
        return {
            $: 'FreezeMetadata',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000000f, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, FreezeMetadata.store);
    }
};
export const ConfigureFreezePolicy = {
    PREFIX: 0xf0000018,
    create(args) {
        return {
            $: 'ConfigureFreezePolicy',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000018, 'ConfigureFreezePolicy');
        return {
            $: 'ConfigureFreezePolicy',
            queryId: s.loadUintBig(64),
            freezeRequiredBeforeMint: s.loadBoolean(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000018, 32);
        b.storeUint(self.queryId, 64);
        b.storeBit(self.freezeRequiredBeforeMint);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureFreezePolicy.store);
    }
};
export const MetadataFrozenEvent = {
    PREFIX: 0xf000f00f,
    create(args) {
        return {
            $: 'MetadataFrozenEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f00f, 'MetadataFrozenEvent');
        return {
            $: 'MetadataFrozenEvent',
            frozenAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f00f, 32);
        b.storeUint(self.frozenAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, MetadataFrozenEvent.store);
    }
};
export const SoulboundConfiguredEvent = {
    PREFIX: 0xf000f022,
    create(args) {
        return {
            $: 'SoulboundConfiguredEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f022, 'SoulboundConfiguredEvent');
        return {
            $: 'SoulboundConfiguredEvent',
            soulbound: s.loadBoolean(),
            configuredAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f022, 32);
        b.storeBit(self.soulbound);
        b.storeUint(self.configuredAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, SoulboundConfiguredEvent.store);
    }
};
export const SubmitMintRequest = {
    PREFIX: 0xf0000030,
    create(args) {
        return {
            $: 'SubmitMintRequest',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000030, 'SubmitMintRequest');
        return {
            $: 'SubmitMintRequest',
            queryId: s.loadUintBig(64),
            quantity: s.loadUintBig(32),
            refundDestination: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000030, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.quantity, 32);
        b.storeAddress(self.refundDestination);
    },
    toCell(self) {
        return makeCellFrom(self, SubmitMintRequest.store);
    }
};
export const FulfillMintRequest = {
    PREFIX: 0xf0000031,
    create(args) {
        return {
            $: 'FulfillMintRequest',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000031, 'FulfillMintRequest');
        return {
            $: 'FulfillMintRequest',
            queryId: s.loadUintBig(64),
            requestId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000031, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.requestId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, FulfillMintRequest.store);
    }
};
export const RejectMintRequest = {
    PREFIX: 0xf0000032,
    create(args) {
        return {
            $: 'RejectMintRequest',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000032, 'RejectMintRequest');
        return {
            $: 'RejectMintRequest',
            queryId: s.loadUintBig(64),
            requestId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000032, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.requestId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RejectMintRequest.store);
    }
};
export const ClaimRefund = {
    PREFIX: 0xf0000033,
    create(args) {
        return {
            $: 'ClaimRefund',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000033, 'ClaimRefund');
        return {
            $: 'ClaimRefund',
            queryId: s.loadUintBig(64),
            requestId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000033, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.requestId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, ClaimRefund.store);
    }
};
export const ConfigureAsyncQueue = {
    PREFIX: 0xf0000034,
    create(args) {
        return {
            $: 'ConfigureAsyncQueue',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000034, 'ConfigureAsyncQueue');
        return {
            $: 'ConfigureAsyncQueue',
            queryId: s.loadUintBig(64),
            requestTtl: s.loadUintBig(32),
            depositMinimum: s.loadCoins(),
            maxPendingPerWallet: s.loadUintBig(32),
            maxSupply: s.loadUintBig(32),
            maxReservedBps: s.loadUintBig(16),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000034, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.requestTtl, 32);
        b.storeCoins(self.depositMinimum);
        b.storeUint(self.maxPendingPerWallet, 32);
        b.storeUint(self.maxSupply, 32);
        b.storeUint(self.maxReservedBps, 16);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureAsyncQueue.store);
    }
};
export const AddMinter = {
    PREFIX: 0xf0000035,
    create(args) {
        return {
            $: 'AddMinter',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000035, 'AddMinter');
        return {
            $: 'AddMinter',
            queryId: s.loadUintBig(64),
            minter: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000035, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.minter);
    },
    toCell(self) {
        return makeCellFrom(self, AddMinter.store);
    }
};
export const RemoveMinter = {
    PREFIX: 0xf0000036,
    create(args) {
        return {
            $: 'RemoveMinter',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000036, 'RemoveMinter');
        return {
            $: 'RemoveMinter',
            queryId: s.loadUintBig(64),
            minter: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000036, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.minter);
    },
    toCell(self) {
        return makeCellFrom(self, RemoveMinter.store);
    }
};
export const RenounceOwnership = {
    PREFIX: 0xf0000013,
    create(args) {
        return {
            $: 'RenounceOwnership',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000013, 'RenounceOwnership');
        return {
            $: 'RenounceOwnership',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000013, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RenounceOwnership.store);
    }
};
export const MintRequestSubmittedEvent = {
    PREFIX: 0xf000f030,
    create(args) {
        return {
            $: 'MintRequestSubmittedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f030, 'MintRequestSubmittedEvent');
        return {
            $: 'MintRequestSubmittedEvent',
            requestId: s.loadUintBig(64),
            requester: s.loadAddress(),
            quantity: s.loadUintBig(32),
            deposit: s.loadCoins(),
            submittedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f030, 32);
        b.storeUint(self.requestId, 64);
        b.storeAddress(self.requester);
        b.storeUint(self.quantity, 32);
        b.storeCoins(self.deposit);
        b.storeUint(self.submittedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, MintRequestSubmittedEvent.store);
    }
};
export const MintRequestFulfilledEvent = {
    PREFIX: 0xf000f031,
    create(args) {
        return {
            $: 'MintRequestFulfilledEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f031, 'MintRequestFulfilledEvent');
        return {
            $: 'MintRequestFulfilledEvent',
            requestId: s.loadUintBig(64),
            requester: s.loadAddress(),
            startIndex: s.loadUintBig(64),
            quantity: s.loadUintBig(32),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f031, 32);
        b.storeUint(self.requestId, 64);
        b.storeAddress(self.requester);
        b.storeUint(self.startIndex, 64);
        b.storeUint(self.quantity, 32);
    },
    toCell(self) {
        return makeCellFrom(self, MintRequestFulfilledEvent.store);
    }
};
export const MintRequestRefundedEvent = {
    PREFIX: 0xf000f033,
    create(args) {
        return {
            $: 'MintRequestRefundedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f033, 'MintRequestRefundedEvent');
        return {
            $: 'MintRequestRefundedEvent',
            requestId: s.loadUintBig(64),
            refundDestination: s.loadAddress(),
            deposit: s.loadCoins(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f033, 32);
        b.storeUint(self.requestId, 64);
        b.storeAddress(self.refundDestination);
        b.storeCoins(self.deposit);
    },
    toCell(self) {
        return makeCellFrom(self, MintRequestRefundedEvent.store);
    }
};
export const ReturnExcessesBack = {
    PREFIX: 0xd53276db,
    create(args) {
        return {
            $: 'ReturnExcessesBack',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xd53276db, 'ReturnExcessesBack');
        return {
            $: 'ReturnExcessesBack',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xd53276db, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, ReturnExcessesBack.store);
    }
};
export const FreezePolicyReply = {
    create(args) {
        return {
            $: 'FreezePolicyReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'FreezePolicyReply' from cell, because 'FreezePolicyReply.frozenAt' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'FreezePolicyReply' to cell, because 'self.frozenAt' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, FreezePolicyReply.store);
    }
};
export const MintRequest = {
    create(args) {
        return {
            $: 'MintRequest',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'MintRequest',
            requester: s.loadAddress(),
            refundDestination: s.loadAddress(),
            quantity: s.loadUintBig(32),
            deposit: s.loadCoins(),
            submittedAt: s.loadUintBig(32),
        };
    },
    store(self, b) {
        b.storeAddress(self.requester);
        b.storeAddress(self.refundDestination);
        b.storeUint(self.quantity, 32);
        b.storeCoins(self.deposit);
        b.storeUint(self.submittedAt, 32);
    },
    toCell(self) {
        return makeCellFrom(self, MintRequest.store);
    }
};
export const AsyncQueue = {
    create(args) {
        return {
            $: 'AsyncQueue',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'AsyncQueue',
            requestTtl: s.loadUintBig(32),
            depositMinimum: s.loadCoins(),
            maxPendingPerWallet: s.loadUintBig(32),
            maxSupply: s.loadUintBig(32),
            reservedSupply: s.loadUintBig(32),
            nextRequestId: s.loadUintBig(64),
            activeMintersCount: s.loadUintBig(32),
            metadataFrozen: s.loadBoolean(),
            freezeRequiredBeforeMint: s.loadBoolean(),
            frozenAt: s.loadUintBig(32),
            soulbound: s.loadBoolean(),
            maxReservedBps: s.loadUintBig(16),
            requests: c.Dictionary.load(c.Dictionary.Keys.BigUint(64), createDictionaryValue(MintRequest.fromSlice, MintRequest.store), s),
            pendingPerWallet: c.Dictionary.load(c.Dictionary.Keys.Address(), c.Dictionary.Values.BigUint(32), s),
            minters: c.Dictionary.load(c.Dictionary.Keys.Address(), c.Dictionary.Values.Bool(), s),
        };
    },
    store(self, b) {
        b.storeUint(self.requestTtl, 32);
        b.storeCoins(self.depositMinimum);
        b.storeUint(self.maxPendingPerWallet, 32);
        b.storeUint(self.maxSupply, 32);
        b.storeUint(self.reservedSupply, 32);
        b.storeUint(self.nextRequestId, 64);
        b.storeUint(self.activeMintersCount, 32);
        b.storeBit(self.metadataFrozen);
        b.storeBit(self.freezeRequiredBeforeMint);
        b.storeUint(self.frozenAt, 32);
        b.storeBit(self.soulbound);
        b.storeUint(self.maxReservedBps, 16);
        b.storeDict(self.requests, c.Dictionary.Keys.BigUint(64), createDictionaryValue(MintRequest.fromSlice, MintRequest.store));
        b.storeDict(self.pendingPerWallet, c.Dictionary.Keys.Address(), c.Dictionary.Values.BigUint(32));
        b.storeDict(self.minters, c.Dictionary.Keys.Address(), c.Dictionary.Values.Bool());
    },
    toCell(self) {
        return makeCellFrom(self, AsyncQueue.store);
    }
};
export const AsyncMinterStorage = {
    create(args) {
        return {
            $: 'AsyncMinterStorage',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'AsyncMinterStorage',
            ownerAddress: s.loadAddress(),
            nextItemIndex: s.loadUintBig(64),
            content: loadCellRef(s, CollectionContent.fromSlice),
            nftItemCode: s.loadRef(),
            queue: loadCellRef(s, AsyncQueue.fromSlice),
        };
    },
    store(self, b) {
        b.storeAddress(self.ownerAddress);
        b.storeUint(self.nextItemIndex, 64);
        storeCellRef(self.content, b, CollectionContent.store);
        b.storeRef(self.nftItemCode);
        storeCellRef(self.queue, b, AsyncQueue.store);
    },
    toCell(self) {
        return makeCellFrom(self, AsyncMinterStorage.store);
    }
};
export const AsyncConfigReply = {
    create(args) {
        return {
            $: 'AsyncConfigReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'AsyncConfigReply' from cell, because 'AsyncConfigReply.requestTtl' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'AsyncConfigReply' to cell, because 'self.requestTtl' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, AsyncConfigReply.store);
    }
};
export const CollectionContent = {
    create(args) {
        return {
            $: 'CollectionContent',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'CollectionContent',
            collectionMetadata: s.loadRef(),
            commonContent: s.loadStringRefTail(),
        };
    },
    store(self, b) {
        b.storeRef(self.collectionMetadata);
        b.storeStringRefTail(self.commonContent);
    },
    toCell(self) {
        return makeCellFrom(self, CollectionContent.store);
    }
};
function calculateDeployedAddress(code, data, options) {
    const stateInitCell = beginCell().store(c.storeStateInit({
        code,
        data,
        splitDepth: options.toShard?.fixedPrefixLength,
        special: null,
        libraries: null,
    })).endCell();
    let addrHash = stateInitCell.hash();
    if (options.toShard) {
        const shardDepth = options.toShard.fixedPrefixLength;
        addrHash = beginCell()
            .storeBits(new c.BitString(options.toShard.closeTo.hash, 0, shardDepth))
            .storeBits(new c.BitString(stateInitCell.hash(), shardDepth, 256 - shardDepth))
            .endCell()
            .beginParse().loadBuffer(32);
    }
    return new c.Address(options.workchain ?? 0, addrHash);
}
export class AsyncMinterCollection {
    static CodeCell = c.Cell.fromBase64('te6ccgECMAEACw4AART/APSkE/S88sgLAQIBYgIDBFLQ+JGRMOAg1ywngAABhOMC1ywngAABjOMC1ywngAABlOMC1ywngAABnAQFBgcCASAmJwH+Me1E0PpI0z/U1NTR0NMf+gDTH9Mf0x/TP9Mf0gDSANMf0gDTD/QE9AT0BNH4kiezkX+TKMMA4vLh1REU0z8x0x/6SDAhwgCVIcELwwCRcOLy4apWFSSBAQv0Cm+hk9Mf0ZIwcOJTAqBWELvy4btWFC6gI6Avu/Lhqy5WFaFT4wgC/jHtRND6SNM/1NTU0dDTH/oA0x/TH9Mf0z/TH9IA0gDTH9IA0w/0BPQE9ATR+JIhgQEL9ApvoTHy4bgRE9M/1ws/UwOAQPQO8uG5+kj6SNMf+gDTHzHRVhZwk1MDuYroMFJZgED0WzARECKhU0eBAQv0Cm+hk9Mf0ZIwcOIjoSAKCwP+Me1E0PpI0z/U1NTR0NMf+gDTH9Mf0x/TP9Mf0gDSANMf0gDTD/QE9AT0BNH4kiGBAQv0Cm+hMfLhuBET0z8x1ws/UwKAQPQO8uG5+kj6SNMf+gDTHzHRUkeAQPRbMFHhoVM1gQEL9ApvoZPTH9GSMHDiIqEgwQHjDxERyMsfAQ8XEAQ24wLXLCeAAAGk4wLXLCeAAABs4wLXLCeAAAGsExQVFgH+oIEnEKhRGKi78uHjggnJw4AjqIIJMS0AoPiXu5f4l1YRvsMAkXDi8uG8IfpEMPLRTSz4I/iXVhnI+lIV+lIlzwsfUAT6AiPPCx9UIAiAQPRDUROgyMsfAVYXUAaBAQv0QVHSoAykERHIyx8BERD6Ah7LHxzLHxnLHx3LPxbLHwkAmBTKABLKAMsfygDLD/QA9AD0AMkHyPpSFss/FMwSzBTMye1UiwL4l8jPk8ADwMIVyz8V+lISyx9Y+gLLP8nIz4cgEs5xzwthzMlw+wABhohTbPgoVhzIyz/6UslWGoIJycOAyM+JiAFdyM+E0MzM+RbPC/8B+gKBAIzPC3DMzBL6UhLMygDPgclx+wARGKQRGKQMAvzBAZkwUkiBAQv0WTCbyMsfVCBZgQEL9EHiERTIyx8BERP6AgEREQHLHx/LHxTLHxvLPxnLHxfKABXKABPLH8oAyw8V9AAY9AAc9ADJCsj6UhnLPxfMFcwXzMntVIIJycOAJqiCCTEtAKBcvJNbNTDjDYsCyM+TwAPAxhPLPxQNDgAedW5yZXZlYWxlZC5qc29uADahyM+FCBP6Ulj6AoIQ1TJ2288LihXLP8ly+wAALvpSE8s/yx/JyM+HIBLOcc8LYczJcPsAABIwUDWBAQv0WTAB/hEQ+gIeyx8cyx/LHxjLPxbLHxTKABLKAMsfygDLDxL0ABX0ABn0AMkHyPpSFss/FMwSzBTMye1UggkxLQCCCExLQFADqBKgIqLIz4UIUiD6UgH6AoIQ8ADwM88LiiPPCz9SEPpSIvoCyXD7AIsCyM+TwAPAzhTLP/pSAfoCycgRARyJzxYSznHPC2HMyXD7ABIAAcgC/DHtRND6SNM/1NTU0dDTH/oA0x/TH9Mf0z/TH9IA0gDTH9IA0w/0BPQE9ATRERPTPzHXCz9TAoBA9A7y4bn6SPpI0x/6ANMf0fgjAVYUoLzy4bpSR4BA9FswUeGhUzWBAQv0Cm+hk9Mf0ZIwcOIioSDBAZkwUDWBAQv0WTDjDhcYAf4x7UTQ+kjTP9TU1NH4kiXHBfLhkQXTPzHTH/oA0x/TH9cLDyCBJxC78uHkCdDTHzH6ADHTHzHTHzHTH9M/0x/SANIA0x/SANMPMfQE9AT0BNENyMsfUAz6AhrLHxjLHxbLHxTLPxLLH8oAygDLH8oAGMsPF/QAFvQAFfQAyQPIGgH8Me1E0PpI0z/U1NTR+JIlxwXy4ZHQ0x/6ANMf0x/TH9M/0x/SANIA0x/SADHTD/QE9AT0BNFWEJFwlSnAAMMA4vLhxxES0z8x1woAUg7Iyx9QDfoCG8sfGcsfF8sfFcs/E8sfygDKAMsfFcoAFMsPE/QAEvQAFvQAyQTI+lITGwT44wLXLCeAAAG04wLXLCeAAACcjl5b7UTQ+kjTP9TU1NH4klAFxwXy4ZEj0NMfMfoAMdMfMdMfMdMfMdM/MdMf0gAx0gAx0x8x0gAx0w8x9AQx9AQx9AQx0fLRvcjPigBAcM8L/89QyPpSE8s/zMzMye1U4NcsJ4AAAHzjAhwdHh8AGMjLH0BGgQEL9EEQJAH8ERHIyx8BERD6Ah7LHxzLH8sfGMs/FssfFMoAEsoAyx/KAMsPEvQAFfQAGfQAyQfI+lIWyz8UzBLMFMzJ7VSCCTEtAIIITEtAUAOoEqAiosjPhQhSIPpSAfoCghDwAPAzzwuKI88LP1IQ+lIi+gLJcPsAiwLIz5PAA8DOFMs/GQAq+lIB+gLJyM+HIBLOcc8LYczJcPsAABj6UhLLP8wSzMzJ7VQASMs/zMzMye1UiwL4I8jPhyASzoIQ8ADwIs8LgRLKAMs/yXD7AAH+Me1E0PpI0z/U1NTR+JIlxwXy4ZHQ0x/6ANMf0x/TH9M/0x/SANIA0x/SANMP9AT0BPQE0RET0z8x+kgwIFYUgQEL9ApvoTGRMI4QyM+DAhEUgQEL9EEHpAcREuINyMsfUAz6AhrLHxjLHxbLHxTLPxLLH8oAygDLH8oAyw/0ACAB/jHtRND6SNM/1NTU0fiSJccF8uGR0NMf+gDTH9Mf0x/TP9Mf0gDSANMf0gDTD/QE9AT0BNERE9M/MfpIMCBWFIEBC/QKb6ExngERE4EBC/RZMAelBxESkTDiDcjLH1AM+gIayx8Yyx8Wyx8Uyz8Syx/KAMoAyx/KAMsP9AD0ABUhAfpb7UTQ+kjTP9TU1NH4kiXHBfLhkdDTH/oA0x/TH9Mf0z/TH9IA0gDTHzHSANMP9AT0BPQE0Qby0db4I1IOyMsfUA36AhvLHxnLHxfLHxXLPxPLH8+DEsoAF8sfygDLD/QA9AAS9ADJBcj6UhTLPxLMzBLMye1UiwLIz4cgziICGonXJ+MCMIQPAccA8vQjJAAo9AAV9ADJA8j6UhLLP8wSzMzJ7VQAIvQAyQPI+lISyz/MEszMye1UAB6CEPAA8A/PC4HLP8lw+wAACPAAABgB/DHtRND6SNM/1NTU0fiSJccF8uGR0NMf+gDTH9Mf0x/TP9Mf0gDSADHTH9IA0w/0BPQE9ATRVhCRcJUpwADDAOLy4dcREtM/MdcKAA3Iyx9QDPoCGssfGMsfFssfFMs/EssfygAWygAVyx8UygATyw8S9AD0ABX0AMkDyPpSEiUAEss/zBLMzMntVAIBICgpAgEgKisAR7rnLtRND6SDHTPzHUMdQx1NHQ0x8x+gAx078x0gDSANcLHxKACBu1RO1E0NQx1DHXTNDTHzH6ADHTHzHTHzHTHzHTPzHTHzHSADHSADHTHzHSADHTDzH0BPQEMfQEMdGAQPQOb6ExgAiblRrtRND6SDHTP9Qx1DHXTNDTH/oA0x/TH9Mf0z/TH9IAMdIAMdMfMdIA0w/0BDH0BDH0BDHREIkQeBBnEFYQRRA0ECOAIBICwtAgEgLi8Al7T9XaiaGoY6hjrpmhpj5j9ABjpj5jpj5jpj5jpn5jpj5jpABjpABjpj5jpABjph5j6AnoCGPoCGOjAIHoHN9CYfSR9JGmP/QBpj+jAAB7DP3OAAg7HT+1E0NQx1DHXTNDTHzH6ADHTHzHTHzHTHzHTPzHTHzHSADHSADHTHzHSADHTDzH0BDH0BDH0BNGBAQv0Cm+hMYA==');
    static Errors = {
        'Errors.InvalidWorkchain': 333,
        'Errors.NotFromAdmin': 401,
        'Errors.InvalidQuantity': 426,
        'Errors.SoldOut': 427,
        'Errors.NotFromMinter': 440,
        'Errors.RequestNotFound': 441,
        'Errors.RequestNotExpired': 442,
        'Errors.WalletPendingLimit': 443,
        'Errors.InsufficientDeposit': 444,
        'Errors.MintersNotEmpty': 445,
        'Errors.SoulboundAfterMint': 455,
        'Errors.MetadataNotFrozen': 469,
        'Errors.MetadataAlreadyFrozen': 470,
        'Errors.FreezePolicyAfterMint': 471,
        'Errors.ReservationCapExceeded': 483,
        'Errors.InvalidReservationCap': 484,
    };
    address;
    init;
    constructor(address, init) {
        this.address = address;
        this.init = init;
    }
    static fromAddress(address) {
        return new AsyncMinterCollection(address);
    }
    static fromStorage(emptyStorage, deployedOptions) {
        const initialState = {
            code: deployedOptions?.overrideContractCode ?? AsyncMinterCollection.CodeCell,
            data: AsyncMinterStorage.toCell(AsyncMinterStorage.create(emptyStorage)),
        };
        const address = calculateDeployedAddress(initialState.code, initialState.data, deployedOptions ?? {});
        return new AsyncMinterCollection(address, initialState);
    }
    static createCellOfSubmitMintRequest(body) {
        return SubmitMintRequest.toCell(SubmitMintRequest.create(body));
    }
    static createCellOfFulfillMintRequest(body) {
        return FulfillMintRequest.toCell(FulfillMintRequest.create(body));
    }
    static createCellOfRejectMintRequest(body) {
        return RejectMintRequest.toCell(RejectMintRequest.create(body));
    }
    static createCellOfClaimRefund(body) {
        return ClaimRefund.toCell(ClaimRefund.create(body));
    }
    static createCellOfConfigureAsyncQueue(body) {
        return ConfigureAsyncQueue.toCell(ConfigureAsyncQueue.create(body));
    }
    static createCellOfConfigureSoulbound(body) {
        return ConfigureSoulbound.toCell(ConfigureSoulbound.create(body));
    }
    static createCellOfAddMinter(body) {
        return AddMinter.toCell(AddMinter.create(body));
    }
    static createCellOfRemoveMinter(body) {
        return RemoveMinter.toCell(RemoveMinter.create(body));
    }
    static createCellOfRenounceOwnership(body) {
        return RenounceOwnership.toCell(RenounceOwnership.create(body));
    }
    static createCellOfFreezeMetadata(body) {
        return FreezeMetadata.toCell(FreezeMetadata.create(body));
    }
    static createCellOfConfigureFreezePolicy(body) {
        return ConfigureFreezePolicy.toCell(ConfigureFreezePolicy.create(body));
    }
    async sendDeploy(provider, via, msgValue, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: c.Cell.EMPTY,
            ...extraOptions
        });
    }
    async sendSubmitMintRequest(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: SubmitMintRequest.toCell(SubmitMintRequest.create(body)),
            ...extraOptions
        });
    }
    async sendFulfillMintRequest(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: FulfillMintRequest.toCell(FulfillMintRequest.create(body)),
            ...extraOptions
        });
    }
    async sendRejectMintRequest(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RejectMintRequest.toCell(RejectMintRequest.create(body)),
            ...extraOptions
        });
    }
    async sendClaimRefund(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ClaimRefund.toCell(ClaimRefund.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureAsyncQueue(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureAsyncQueue.toCell(ConfigureAsyncQueue.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureSoulbound(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureSoulbound.toCell(ConfigureSoulbound.create(body)),
            ...extraOptions
        });
    }
    async sendAddMinter(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: AddMinter.toCell(AddMinter.create(body)),
            ...extraOptions
        });
    }
    async sendRemoveMinter(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RemoveMinter.toCell(RemoveMinter.create(body)),
            ...extraOptions
        });
    }
    async sendRenounceOwnership(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RenounceOwnership.toCell(RenounceOwnership.create(body)),
            ...extraOptions
        });
    }
    async sendFreezeMetadata(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: FreezeMetadata.toCell(FreezeMetadata.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureFreezePolicy(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureFreezePolicy.toCell(ConfigureFreezePolicy.create(body)),
            ...extraOptions
        });
    }
    async getAbiVersion(provider) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_abi_version', []));
        return r.readBigInt();
    }
    async getAsyncConfig(provider) {
        const r = StackReader.fromGetMethod(10, await provider.get('get_async_config', []));
        return ({
            $: 'AsyncConfigReply',
            requestTtl: r.readBigInt(),
            depositMinimum: r.readBigInt(),
            maxPendingPerWallet: r.readBigInt(),
            maxSupply: r.readBigInt(),
            reservedSupply: r.readBigInt(),
            nextRequestId: r.readBigInt(),
            activeMintersCount: r.readBigInt(),
            nextItemIndex: r.readBigInt(),
            soulbound: r.readBoolean(),
            maxReservedBps: r.readBigInt(),
        });
    }
    async getMintRequest(provider, requestId) {
        const r = StackReader.fromGetMethod(5, await provider.get('get_mint_request', [
            { type: 'int', value: requestId },
        ]));
        return ({
            $: 'MintRequest',
            requester: r.readSlice().loadAddress(),
            refundDestination: r.readSlice().loadAddress(),
            quantity: r.readBigInt(),
            deposit: r.readBigInt(),
            submittedAt: r.readBigInt(),
        });
    }
    async getHasMintRequest(provider, requestId) {
        const r = StackReader.fromGetMethod(1, await provider.get('has_mint_request', [
            { type: 'int', value: requestId },
        ]));
        return r.readBoolean();
    }
    async getIsMinter(provider, wallet) {
        const r = StackReader.fromGetMethod(1, await provider.get('is_minter', [
            { type: 'slice', cell: makeCellFrom(wallet, (v, b) => b.storeAddress(v)) },
        ]));
        return r.readBoolean();
    }
    async getFreezePolicy(provider) {
        const r = StackReader.fromGetMethod(3, await provider.get('get_freeze_policy', []));
        return ({
            $: 'FreezePolicyReply',
            freezeRequiredBeforeMint: r.readBoolean(),
            metadataFrozen: r.readBoolean(),
            frozenAt: r.readBigInt(),
        });
    }
}
